/* Goodly Lane · Day & Date Clock — carregado SOMENTE pelo layout theme.clock.liquid */
(function () {
  'use strict';
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------- Rolagem suave até a compra ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-dc-scroll]');
    if (!a) return;
    var target = qs('.product__info-container') || qs('#MainContent');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- Formulário nativo do Dawn ---------- */
  function mainBtn() { return qs('.product product-form .product-form__submit') || qs('product-form .product-form__submit'); }
  function nativeInputs() { return qsa('.product__info-container variant-selects input[type="radio"]'); }
  function chooseNative(val) {
    var inp = nativeInputs().filter(function (i) { return i.value === val; })[0];
    if (inp) { if (!inp.checked) inp.click(); return; }
    qsa('.product__info-container variant-selects select').forEach(function (sel) {
      var has = Array.prototype.some.call(sel.options, function (o) { return o.value === val; });
      if (has && sel.value !== val) { sel.value = val; sel.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  }
  function nativeHas(val) {
    if (nativeInputs().some(function (i) { return i.value === val && i.checked; })) return true;
    return qsa('.product__info-container variant-selects select').some(function (s) { return s.value === val; });
  }

  /* ---------- Cartões de cor ---------- */
  function paintColors() {
    qsa('[data-dc-colors] .dc-color').forEach(function (b) {
      var on = nativeHas(b.getAttribute('data-value'));
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-dc-colors] .dc-color');
    if (!b) return;
    qsa('.dc-color', b.closest('[data-dc-colors]')).forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
    chooseNative(b.getAttribute('data-value'));
    setTimeout(function () { refresh(); }, 80);
  });

  /* ---------- Barra fixa ---------- */
  var bar = qs('[data-dc-sticky]');
  var sbtn = bar && qs('[data-dc-sticky-btn]', bar);
  var label = sbtn ? sbtn.textContent : '';
  function syncSticky() {
    if (!bar || !sbtn) return;
    var b = mainBtn();
    if (!b) return;
    var off = b.hasAttribute('disabled') || b.getAttribute('aria-disabled') === 'true';
    sbtn.disabled = off;
    var span = qs('span', b);
    sbtn.textContent = off && span ? span.textContent.trim() : label;
    var price = qs('.product__info-container .price-item--sale, .product__info-container .price-item--regular');
    var sub = qs('[data-dc-sticky-sub]', bar);
    var on = qs('[data-dc-colors] .dc-color.is-on');
    if (sub && price) sub.textContent = (on ? on.getAttribute('data-value') + ' · ' : '') + price.textContent.trim();
  }
  if (bar && sbtn) {
    sbtn.addEventListener('click', function () { var b = mainBtn(); if (b && !b.disabled) b.click(); });
    if (mainBtn()) {
      bar.hidden = false;
      var ticking = false;
      var check = function () { ticking = false; var b = mainBtn(); bar.classList.toggle('is-on', b ? b.getBoundingClientRect().bottom < 0 : false); };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(check); } }, { passive: true });
      window.addEventListener('resize', check);
      check();
    }
  }

  /* ---------- Sincronização com o Dawn ---------- */
  function refresh() { paintColors(); syncSticky(); }
  refresh();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(refresh, 60); });
  }
  var info = qs('.product__info-container');
  if (info && 'MutationObserver' in window) {
    var tm;
    new MutationObserver(function (muts) {
      var relevant = muts.some(function (m) { return !(m.target.closest && m.target.closest('[data-dc-colors]')); });
      if (!relevant) return;
      clearTimeout(tm); tm = setTimeout(refresh, 40);
    }).observe(info, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'checked'] });
  }
})();
